import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Es tut uns leid, dass der Artikel nicht hilfreich war. Können Sie uns mitteilen, was falsch war?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Die von mir gesuchten Informationen fehlen',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Es gibt sachliche Fehler',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Einige Fragen sind unklar',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Geben Sie uns einige Hintergrundinformationen und wir werden diesen Artikel verbessern.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Senden Sie'
    }
  }
};
